import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { aiWorkflowsAllowedEmails } from '@agilox/common';
import { UserStoreService } from '@user-store';
import { MenuPointUrl } from '../models/enums/menupoint-url.enum';

export const aiWorkflowsGuard: CanActivateFn = (): boolean | UrlTree => {
	const userStore = inject(UserStoreService);
	const router = inject(Router);
	const user = userStore.currentUser();

	const hasAccess = user?.email && aiWorkflowsAllowedEmails.includes(user.email.toLowerCase());

	if (hasAccess) {
		return true;
	}

	return router.parseUrl(MenuPointUrl.DASHBOARD);
};
